import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { DialogContent } from '@mui/material';
import { DateTime } from 'luxon';
import { TRequestChangeDialogProps } from './types';
import { DATE_START_CHANGE_REQUEST } from '../constants';

export const RequestChangeDialog: FC<TRequestChangeDialogProps> = ({
	open,
	setClose,
	handleClick,
	text,
}) => {
	return (
		<Dialog
			open={open}
			onClose={setClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle>{text}</DialogTitle>
			<DialogContent>
				The new plan will take effect on{' '}
				{DateTime.now()
					.plus({ month: 1 })
					.set({
						day: DATE_START_CHANGE_REQUEST,
					})
					.toFormat('yyyy-MM-dd')}
				.
			</DialogContent>
			<DialogActions>
				<Button onClick={setClose}>Cancel</Button>
				<Button onClick={handleClick} autoFocus>
					Request Change
				</Button>
			</DialogActions>
		</Dialog>
	);
};
